import { Navigate, Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import AdminLayout from './layouts/AdminLayout';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import OrganizationsPage from './pages/OrganizationsPage';
import WorkspacesPage from './pages/WorkspacesPage';
import TenantsPage from './pages/TenantsPage';
import AccessesPage from './pages/AccessesPage';
import DocumentationPage from './pages/DocumentationPage';
import { useAuth } from './auth/AuthContext';

export default function App() {
  const { state } = useAuth();

  // Hold rendering until the stored token has been probed, so a signed-in
  // reload doesn't flash the login form on its way to the console.
  if (state === 'checking') {
    return (
      <div className="login-shell">
        <Spin size="large" />
      </div>
    );
  }

  if (state !== 'authenticated') {
    return (
      <Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/users" element={<UsersPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/workspaces" element={<WorkspacesPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/accesses" element={<AccessesPage />} />
        <Route path="/documentation" element={<DocumentationPage />} />
        {/* The screen was /access-requests until it grew a grants tab worth
            linking to on its own. Kept as a redirect for existing bookmarks. */}
        <Route path="/access-requests" element={<Navigate to="/accesses" replace />} />
        <Route path="*" element={<Navigate to="/users" replace />} />
      </Route>
    </Routes>
  );
}
